<div class="chip" 
    [ngClass]="{'grabbable': draggable === true}"
    *ngFor="let obj of itemList; let i = index"
    draggable="{{draggable}}"
    (dragover)="allowDropChipList($event,i)"
    (dragstart)="onDragChipList(i)"
    (drop)="onDropChipList($event, i)">

    {{getLabel(obj)}}
    
    <span [hidden]="!cancelSelectedIsEnabled" class="closebtn" (click)="cancelSelected(obj.id)">&times;</span>
</div>
